import { memo } from 'react'

import { Text } from 'common-components'

import * as Styled from './styled'
import MusicVersioningVersions from './versions'
import ActiveTrackName from './active-track-name'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

const MusicVersioningVersionsSection = () => {
  return (
    <Styled.VersionsSectionContainer>
      <Styled.VersionsTopSection>
        <Text type="h2">{translate(T.VERSIONS)}</Text>
        <ActiveTrackName />
      </Styled.VersionsTopSection>

      <MusicVersioningVersions />
    </Styled.VersionsSectionContainer>
  )
}

export default memo(MusicVersioningVersionsSection)
